import segment from 'src/js/modules/analytics/segment';

const trackBlockLayoutSwitchTemplateButtonClicked = () => {
  const {
    trackers: { trackEvent },
    constants,
  } = segment;

  trackEvent(constants.events.BLOCK_LAYOUT_SWITCH_TEMPLATE_BUTTON_CLICKED);
};

export default trackBlockLayoutSwitchTemplateButtonClicked;
